module.exports = __webpack_public_path__ + "static/mdk_logo-257ab222667fc74774e9c710190d7cc9.png";